import { fetchHelper } from "./helpers";
import { FetchResponse } from "./helper";

export async function fetchGet<T>(
  apiPath: string,
  includeToken: boolean = true,
  includeSessionKey: boolean = true,
): Promise<FetchResponse<T>> {
  return fetchHelper<T>(apiPath, { includeToken,includeSessionKey });
}

export async function fetchPost<T, U = Record<string, unknown>>(
  apiPath: string,
  data: U | FormData,
  isMultipart: boolean = false,
  includeToken: boolean = true,
  excludeRefresh : boolean = true,
  errorMessage?: any,
  includeSessionKey: boolean = true,
): Promise<FetchResponse<T>> {
  return fetchHelper<T, U>(
    apiPath, { method: 'POST', data, isMultipart, includeToken, errorMessage, includeSessionKey ,excludeRefresh }
  );
} 

export async function fetchPut<T, U = Record<string, unknown>>(
  apiPath: string,
  data: U | FormData,
  isMultipart: boolean = false,
  includeToken: boolean = true,
  errorMessage?: string,
  includeSessionKey: boolean = true,
): Promise<FetchResponse<T>> {
  return fetchHelper<T, U>(
    apiPath, { method: 'PUT', data, isMultipart, includeToken, errorMessage, includeSessionKey }
  );
}

export async function fetchPatch<T, U = Record<string, unknown>>(
  apiPath: string,
  data: U | FormData,
  isMultipart: boolean = false,
  includeToken: boolean = true,
  errorMessage?: string,
): Promise<FetchResponse<T>> {
  return fetchHelper<T, U>(
    apiPath, { method: 'PATCH', data, isMultipart, includeToken, errorMessage }
  );
}

export async function fetchDelete<T>(
  apiPath: string,
  includeToken: boolean = true,
  errorMessage?: string,
): Promise<FetchResponse<T>> {
  return fetchHelper<T>(
    apiPath, { method: 'DELETE', includeToken, errorMessage }
  );
}